export default __webpack_public_path__ + "static/char-s-20-en-0eb94561d578e0a9f428e162b169b890.webp";